/* eslint-disable import/prefer-default-export */
import dayjs from '../config/dayjs';

export const diffDaysToTooltipText = (date) => {
  const today = dayjs().startOf('day');
  const daysDiff = date.diff(today, 'days');
  if (daysDiff < 0) {
    return 'Factura en mora';
  }
  if (daysDiff < 5) {
    return 'Factura por vencer';
  }
  return 'Factura al día';
};

export const diffDaysToShowIcon = (date) => {
  const today = dayjs().startOf('day');
  const daysDiff = date.diff(today, 'days');
  if (daysDiff < 5) {
    return true;
  }
  return false;
};
